module.exports = __webpack_public_path__ + "img/new-logo.621d95e3.png";